import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'

const scrollTop = () => { window.scrollTo({ top: 0, behavior: "smooth" }) }

function FrontpageInfo() {

    return (
        <>
            <div className={`info-area pt-110 pb-110`}>
                <div className="container">

                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-lg-6 col-sm-10">
                            <div className="section-head-alpha">
                                <h2>Next-level arts residencies</h2>
                                <p>Nestled in the French pyrenees at 750m altitude, 10km from the Spanish border and surrounded by snowcapped peaks, waterfalls and forests, is the picturesque thermal village of Aulus-les-bains. In the village, housed in a beautifully renovated 19th century hotel, is CAMP - the first of a new breed of arts residency. CAMP runs 5-day arts, music, writing, and activism workshops, alongside a packed online program and self-guided residency opportunities.</p>
                                
                                <p>Onsite or online, these are no ordinary workshops - they are intense, artistic catalysts run by internationally acclaimed practitioners; creative flashpoints designed to change the lives of everyone involved. Check out the <a href="/workshops">workshops</a> for full details.</p>

                                <div className="sp_20"></div>

                                <a href="/about" className="button-fill-primary all-package-btn">More about us</a>

                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-10">
                            <div className="video-container">
                                <iframe src="https://www.youtube.com/embed/cLMBzmTb2mQ" frameborder="0" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default FrontpageInfo